import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

export default function Loader({ loading, message, style = {}, iconStyle = {}, children }) {
	if (loading) {
		return (
			<div className="row justify-content-end align-items-center mr-4">
				<CircularProgress />&nbsp;{message}
			</div>
		);
	}

	return children || null;
}



// WEBPACK FOOTER //
// ./src/components/common/Loader.js